import { render, staticRenderFns } from "./FeedbackItemCard.vue?vue&type=template&id=288da7b0&scoped=true&"
import script from "./FeedbackItemCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackItemCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackItemCard.vue?vue&type=style&index=0&id=288da7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288da7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VIcon,VProgressCircular,VSpacer})
